import { render, staticRenderFns } from "./PazienteAnagraficaEditor.vue?vue&type=template&id=d3639f84&"
import script from "./PazienteAnagraficaEditor.vue?vue&type=script&lang=js&"
export * from "./PazienteAnagraficaEditor.vue?vue&type=script&lang=js&"
import style0 from "./PazienteAnagraficaEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports